import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import cx from 'classnames';
import { customGaEvent, PublicGaEvents } from '../../../../../utils/ga';
import ButtonHoverRender from '../../../../Buttons/ButtonHover/ButtonHoverRender';
import ButtonHoverText from '../../../../Buttons/ButtonHover/ButtonHoverText';
import './MediaButtons.scss';

class MediaButtons extends Component {
  constructor() {
    super();
    this.state = {
      showGallery: false,
    };
  }

  fireGoogleAnalyticsEvent = mediaType => {
    if (!mediaType) return;

    customGaEvent({
      action: PublicGaEvents.MEDIA_INFO_OPEN,
      label: mediaType,
    });
  };

  handleClick = event => {
    if (!event) return;

    const { toggleGallery } = this.props;
    toggleGallery(event);
    this.fireGoogleAnalyticsEvent(event.target.name);
  };

  render() {
    const { stopImages, stopVideos, primaryColor, t } = this.props;
    const hasStopImages = Boolean(stopImages?.length);
    const hasStopVideos = Boolean(stopVideos?.length);
    const videosBtnLabel = `${t('publicTour.ada.additionalMedia.videosLabel')}, ${t('publicTour.ada.additionalMedia.itemCount', {
      count: stopVideos.length,
    })}`;
    const imagesBtnLabel = `${t('publicTour.ada.additionalMedia.imagesLabel')}, ${t('publicTour.ada.additionalMedia.itemCount', {
      count: stopImages.length,
    })}`;
    const classes = cx({
      'media-btn-wrapper': true,
      hide: !hasStopImages && !hasStopVideos,
    });
    return (
      <div className={classes}>
        {hasStopImages && (
          <ButtonHoverRender
            render={({ onEnter, onLeave, hovering }) => (
              <ButtonHoverText
                hovering={hovering}
                onEnter={onEnter}
                onLeave={onLeave}
                color="#4a4a4a"
                hoverTextColor={primaryColor}
                name="Images"
                className="additional-media-btn photo-btn"
                handleClick={this.handleClick}
                data-cy="tour-stop-media-box__images-btn"
                aria-label={imagesBtnLabel}
              >
                <i aria-hidden="true" className="material-icons">
                  photo_size_select_actual
                </i>
                {t('publicTour.media.images')}
                <span className="media-count">{stopImages.length}</span>
              </ButtonHoverText>
            )}
          />
        )}
        {hasStopVideos && (
          <ButtonHoverRender
            render={({ onEnter, onLeave, hovering }) => (
              <ButtonHoverText
                onEnter={onEnter}
                onLeave={onLeave}
                hovering={hovering}
                color="#4a4a4a"
                hoverTextColor={primaryColor}
                name="Videos"
                className="additional-media-btn video-btn"
                handleClick={this.handleClick}
                data-cy="tour-stop-media-box__videos-btn"
                aria-label={videosBtnLabel}
              >
                <i aria-hidden="true" className="material-icons">
                  video_library
                </i>
                {t('publicTour.media.videos')}
                  <span className="media-count" aria-hidden="true">{stopVideos.length}</span>
              </ButtonHoverText>
            )}
          />
        )}
      </div>
    );
  }
}

export default withTranslation()(MediaButtons);
